module.exports = __webpack_public_path__ + "static/media/isotype-mapfre-economics.09c5df1c.svg";